import api from "../utils/axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const AGENCY_PARTIES_KEY = ["agencyParties"];

// GET all agency parties (optional ?search= to filter by company/email/abn/licence)
export const useAgencyPartiesQuery = (search) => {
  return useQuery({
    queryKey: search ? [...AGENCY_PARTIES_KEY, search] : AGENCY_PARTIES_KEY,
    queryFn: async () => {
      const params = search ? `?search=${encodeURIComponent(search)}` : "";
      const res = await api.get(`/admin/agencyParty${params}`);
      return res.data?.data || [];
    },
  });
};

// GET single agency party by ID
export const useAgencyPartyByIdQuery = (id, options = {}) => {
  return useQuery({
    queryKey: [...AGENCY_PARTIES_KEY, id],
    queryFn: async () => {
      const res = await api.get(`/admin/agencyParty/${id}`);
      return res.data?.data || null;
    },
    enabled: !!id,
    ...options,
  });
};

// CREATE agency party
export const useAddAgencyPartyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      const res = await api.post("/admin/agencyParty", data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENCY_PARTIES_KEY });
    },
    ...options,
  });
};

// UPDATE agency party
export const useUpdateAgencyPartyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      const res = await api.put(`/admin/agencyParty/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENCY_PARTIES_KEY });
    },
    ...options,
  });
};

// DELETE agency party
export const useDeleteAgencyPartyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/admin/agencyParty/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENCY_PARTIES_KEY });
    },
    ...options,
  });
};
